<template>
  <ul class="containerPeopleSuggestionsGeneric" v-if="suggestions.length">
    <li class="containerPeopleSuggestionsGeneric__item"
      @mousedown.prevent="selectItem(item.email)"
      v-for="item in suggestions"
      :key="item.index">
      <figure class="containerPeopleSuggestionsGeneric__item--image">
        <img class="suggestionsImage" :src="item.thumbnail" :alt="item.name">
      </figure>
      <div class="containerPeopleSuggestionsGeneric__item--info">
        <p class="suggestionsName">{{item.name}}</p>
        <p class="suggestionsEmail">{{item.email}}</p>
      </div>
    </li>
  </ul>
</template>

<script>
import { ref, watch } from 'vue'
import { searchUser } from '../../../services'

export default {
  name: 'peopleSuggestionsGeneric',
  emits: [
    'onSelectItem'
  ],
  props: {
    searchParameter: {
      type: String,
      default: ''
    },
    selectedMails: {
      type: Array,
      default: () => []
    },
    hideUserLogged: {
      type: Boolean,
      default: false
    },
    maxSuggestions: {
      type: Number,
      default: 6
    },
    userLogged: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const suggestions = ref([])
    const throttleTimer = ref(0)

    /**
     * @description Watch changes on searchParameter prop.
     * @param {string} newSearchParameter New searchParameter value.
     */
    watch(() => props.searchParameter, (newSearchParameter) => {
      launchSuggestions(newSearchParameter)
    })

    /**
     * @description Emits onSelectItem event
     * @param email mail as string
     */
    function selectItem (email) {
      emit('onSelectItem', email)
      suggestions.value = []
    }

    /**
    * @description Launches function to get search suggestion for user's input.
    * @param searchTermParam search term given by the user.
    */
    function launchSuggestions (newSearchParameter) {
      if (newSearchParameter.length >= 3) {
        clearTimeout(throttleTimer.value)
        throttleTimer.value = setTimeout(() => {
          searchUser(newSearchParameter, 100).then(response => {
            const filteredData = response.filter(item => !props.selectedMails.includes(item.email) && (props.hideUserLogged ? props.userLogged !== item.email : true))
            if (filteredData.length && props.searchParameter.length >= 3) {
              suggestions.value = filteredData.slice(0, props.maxSuggestions)
            } else {
              suggestions.value = []
            }
          })
        }, 500)
      } else {
        clearTimeout(throttleTimer.value)
        suggestions.value = []
      }
    }

    return {
      suggestions,
      launchSuggestions,
      selectItem
    }
  }
}
</script>
